/**
 * Geometry for the operator-facing UI.
 *
 * Desktop values favor repeated, information-dense work. The responsive values
 * deliberately restore a 44px minimum target when pointer precision cannot be
 * assumed. Keeping these numbers in one contract prevents individual admin
 * screens from inventing their own notion of "compact".
 */
export const adminDensity = {
  shell: {
    topBar: 48,
    mobileTopBar: 52,
    sidebar: 240,
    collapsedSidebar: 56,
  },
  page: {
    paddingBlock: 16,
    paddingInline: 24,
    mobilePadding: 16,
  },
  control: {
    small: 32,
    standard: 36,
    input: 38,
    touch: 44,
  },
  table: {
    compactRow: 32,
    standardRow: 38,
    fontSize: 13,
    headerFontSize: 13,
    compactCellPaddingBlock: 6,
    standardCellPaddingBlock: 9,
    cellPaddingInline: 12,
  },
  typography: {
    body: 14,
    table: 13,
    pageTitle: 24,
  },
} as const;

export type AdminDensity = typeof adminDensity;
